module.exports = require("worker-loader");